import ArriveDestinationCountry from "~/components/TrackTrace/Statuses/ArriveDestinationCountry";
import Delivery from "~/components/TrackTrace/Statuses/Delivery";
import DepartOriginCountry from "~/components/TrackTrace/Statuses/DepartOriginCountry";
import Processing from "~/components/TrackTrace/Statuses/Processing";
import { ShipmentState } from "~/components/TrackTrace/types";

export default {
  [ShipmentState.PROCESSING]: Processing,
  [ShipmentState.DEPART_ORIGIN_COUNTRY]: DepartOriginCountry,
  [ShipmentState.ARRIVE_DESTINATION_COUNTRY]: ArriveDestinationCountry,
  [ShipmentState.LOCAL_SHIPPING_PROVIDER]: ArriveDestinationCountry,
  [ShipmentState.DELIVERY]: Delivery
};



// WEBPACK FOOTER //
// ./src/helpers/shipmentStateDescriptions.ts